import {Component, Input, OnInit} from '@angular/core';

import {NbMenuService, NbSidebarService} from '@nebular/theme';

import {StateService} from '../../../state/state.service';
import {AuthService} from '../../../core/auth/auth.service';

@Component({
  selector: 'app-ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  @Input() position = 'normal';

  user: any;
  userName: string;

  constructor(private auth: AuthService,
              private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private stateService: StateService) {
  }

  ngOnInit() {
    this.userName = this.stateService.snapshot.auth.email;
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  logout() {
    this.auth.logout();
  }

  goToHome() {
    this.menuService.navigateHome();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/panel-cli-layout/header/header.component.ts